import Vue from "vue";
import Editor from "@/components/Editor";

Vue.use(Editor);
